<template>
  <!--  急救指引-->
  <div class="guiding">
    <el-row :gutter="20">
      <el-col :span="12">
        <swiper
          class="mySwiper swiper-container-h"
          :space-between="50"
          :css-mode="true"
          :mousewheel="true"
          :keyboard="true"
          :allow-touch-move="false"
          :pagination="{ clickable: true }"
          :observer="true"
          :observe-parents="true"
          :observe-slide-children="true"
        >
          <swiper-slide>
            <car-video
              :video-src="videoType1"
              :has-permission="hasPermission"
            />
            <!-- 这种属于直播类型的监控视频,只有护士 ||信息科需要请求权限 -->
            <div v-show="isNurse">
              <!-- 如果不是护士的话,下面的代码直接不用显示了 -->
              <el-button v-if="!hasPermission" class="permission-button" @click="getPermissionForLive">
                <!-- 如果是护士的话,再看看有没有权限 -->
                请求权限
              </el-button>
            </div>
          </swiper-slide>
          <swiper-slide>
            <electrocardiogram
              :video-src="videoType2"
            />
          </swiper-slide>
          <swiper-slide>
            <div class="predicateTime">
              预计花费时间：
              <span>{{ leftTime || 0 }}分钟</span>
            </div>
            <guide-map
              :car-i-d="carID"
              @getLeftTime="getLeftTime"
            />

          </swiper-slide>
          <swiper-slide/>
        </swiper>
      </el-col>
      <el-col :span="11">
        <div class="liveCameraInfo">
          <div class="liveCameraBox">
            <div class="liveCameraChoices">
              <el-menu @select="handleSelect">
                <el-submenu index="1">
                  <template #title> 卒中</template>
                  <el-menu-item index="1-1">项目1</el-menu-item>
                  <el-menu-item index="1-2">项目2</el-menu-item>
                  <el-menu-item index="1-3">项目3</el-menu-item>
                </el-submenu>
                <el-submenu index="2">
                  <template #title>外科</template>
                  <el-menu-item index="2-1">摔伤</el-menu-item>
                  <el-menu-item index="2-2">错位</el-menu-item>
                </el-submenu>
                <el-submenu index="3">
                  <template #title> 胸痛</template>
                  <el-menu-item index="3-1">项目1</el-menu-item>
                </el-submenu>
              </el-menu>
            </div>

            <div class="liveCameraText">
              <div class="text-container">
                <!-- 一,卒中  -->
                <div class="guidingItem">我是卒中 第一项</div>
                <div class="guidingItem">我是卒中 第二项</div>
                <div class="guidingItem">我是卒中 第三项</div>
                <!--二,外科   -->
                <div class="guidingItem">我是外科 第一项</div>
                <div class="guidingItem">我是外科 第二项</div>
                <!--二,胸痛   -->
                <div class="guidingItem">我是胸痛 第一项</div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper.scss";
import "swiper/components/pagination/pagination.min.css";
import SwiperCore, { Pagination } from "swiper/core";
import GuideMap from "@components/MapContainer/GuideMap";
import CarVideo from "@/components/stream/CarVideo";
import Electrocardiogram from "@/components/stream/Electrocardiogram";
import { getStreamToken } from "@api/streamdata";
import { srsRtcUrl } from "@/utils/basic";
import { mapState } from "vuex";
import { getPermission } from "@api/user";
import { askPermission } from "@api/permission";
import "@/assets/css/guiding.css";

SwiperCore.use([Pagination]);

export default {
  name: "Guiding",
  components: {
    Swiper,
    SwiperSlide,
    CarVideo,
    Electrocardiogram,
    GuideMap,
  },
  data() {
    return {
      videoType2: "webrtc://", // 摄像头和麦克风
      videoType1: "webrtc://", // 救护仪器
      hasPermission: false, // 总的判断是否有权限
      isNurse: false,
      leftTime: "", // 急救车返程时间
      carID: 0,
      timer: null,
    };
  },
  computed: {
    ...mapState({
      userInfo: "userInfo",
      hospitalID: "hospitalID"
    })
  },
  mounted() {
    const { id } = this.$route.params;
    this.carID = id * 1;
    this.checkPermission();
    this.getStreamInfo();
  },
  beforeUnmount() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    getStreamInfo() {
      getStreamToken(this.carID).then(({ code, data }) => {
        if (code === 200 || code === 405) {
          const type1 = data.find(e => {
            return e.type === 1;
          });
          const type2 = data.find(e => {
            return e.type === 2;
          });
          if (type1) {
            this.videoType1 = srsRtcUrl + `${type1.app}/${type1.stream}?token=${type1.token}`; // 摄像头和麦克风
          }
          if (type2) {
            this.videoType2 = srsRtcUrl + `${type2.app}/${type2.stream}?token=${type2.token}`; // 救护仪器
          }
        }
      }).catch(
        (e) => console.log(e));
    },
    getLeftTime(leftTime) {
      this.leftTime = Math.round(leftTime / 60);
    },
    async getPermissionForLive() {
      // 如果护士没有权限,则去请求权限
      const form = {
        userId: this.userInfo.id,
        hospitalId: this.hospitalID,
        type: "checkLive",
        ambulanceId: this.carID
      };
      await askPermission(form);
      this.timer = window.setInterval(() => {
        this.checkPermission();
        console.log("检查获得没");
      }, 5000);
    },
    handleSelect(key, keyPath) {
      const items = document.getElementsByClassName("guidingItem");
      for (let item = 0; item < items.length; item++) {
        items[item].style.display = "none";
      }
      switch (key) {
        case "1-1":
          console.log("1-1");
          items[0].style.display = "block";
          break;
        case "1-2":
          console.log("1-2");
          items[1].style.display = "block";
          break;
        case "1-3":
          console.log("1-3");
          items[2].style.display = "block";
          break;
        case "2-1":
          console.log("2-1");
          items[3].style.display = "block";
          break;
        case "2-2":
          console.log("2-2");
          items[4].style.display = "block";
          break;
        case "3-1":
          console.log("3-1");
          items[5].style.display = "block";
          break;
      }
    },
    checkPermission() {
      const { loginUserId } = this.userInfo;
      this.isNurse = loginUserId === 3;
      if (!this.isNurse) { // 不是护士之类的直接就能看, 护士的话, 需要申请权限
        this.hasPermission = true;
        return;
      }
      const form = {
        checkAmbulanceId: this.carID,
        userId: this.userInfo.id,
        type: "checkUserPermission",
      };
      // 查询当前用户是否已经有 监控视频权限
      const { code } = getPermission(form);
      /*
      * 等于1 即是有权限 有权限,可以看 可能护士已经申请过了,并且已经通过了
      * */
      this.hasPermission = code === "1";
      if (this.timer && code === "1") {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
html,
body {
  position: relative;
}

.swiper-container {
  width: 100%;
  height: 100%;
  margin-left: 106px;
}

.mySwiper {
  height: 660px;
  width: 760px;
  padding-top: 102px;
}

.permission-button {
  position: absolute;
  top: 45%;
  right: 45%;
  bottom: 45%;
  height: 50px;
  background: #0c618b77;
  box-shadow: 0 0 6px 0 rgba(6, 53, 76, 0.5);
  border-radius: 6px;
  font-size: 18px;
  font-weight: bold;
  color: #efefef;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-container-v {
  background: #eee;
}

/*页面右侧的相关*/
.liveCameraInfo {
  height: 100%;
}

.liveCameraBox {
  width: 100%;
  margin-left: 110px;
  padding-top: 102px;
  display: flex;
}

.liveCameraChoices {
  width: 150px;
  height: 660px;
  background: #0c618b;
}

.el-tree {
  padding-top: 25px;
  background: transparent;
}

.liveCameraText {
  overflow: auto;
  width: 460px;
  height: 660px;
  color: #333333;
  background-color: #fbfbfb;

  .text-container {
    margin: 40px 40px 0 40px;
  }
}

.predicateTime {
  position: absolute;
  left: 3px;
  bottom: 80px;
  width: 185px;
  height: 30px;
  background: #efefef;
  box-shadow: 0 0 6px 0 rgba(6, 53, 76, 0.5);
  z-index: 161;
  text-align: center;
  vertical-align: bottom;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #666666;
}

.guidingItem {
  display: none;
}
</style>
